import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type { RestigoCallLogsPage, RestigoCallLogsQuery } from 'shared-models/browser';

export type {
  RestigoCallLogView,
  RestigoCallLogsPage,
  RestigoCallLogsQuery,
  RestigoCallStatus,
  RestigoReportKind,
} from 'shared-models/browser';

class AdminRestigoService {
  async list(query: RestigoCallLogsQuery = {}): Promise<RestigoCallLogsPage> {
    try {
      const response = await authenticatedInstance.get<RestigoCallLogsPage>('/restigo/call-logs', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת מעקב רסטיגו נכשלה'));
    }
  }

  async resend(tenantId: string, sessionId: number): Promise<void> {
    try {
      await authenticatedInstance.post<void>(`/restigo/${tenantId}/${sessionId}/resend`);
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'שליחה חוזרת לרסטיגו נכשלה'));
    }
  }
}

export const adminRestigoService = new AdminRestigoService();
